import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import { ShopProvider } from "./context/ShopContext";
import { AnalyticsScripts } from "./components/AnalyticsScripts";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <ShopProvider>
        <AnalyticsScripts />
        <App />
      </ShopProvider>
    </HelmetProvider>
  </StrictMode>
);
